<template>
  <v-dialog width="100%" max-width="360px" v-model="dialog_visible">
    <template #activator="{ on, attrs }">
      <v-btn
        fab x-small rounded dark 
        class="ml-2" color="grey darken-1"
        v-bind="attrs" v-on="on"
      >
        <v-icon>mdi-tune</v-icon>
      </v-btn>
    </template>

    <div class="white rounded-lg pa-3">
      <h2>Narrow your Search</h2>

      <v-divider />
      
      <div>
        <div class="d-flex align-center">
          <div style="white-space: nowrap" class="mr-3">Show only open Leads:</div>
          <v-switch
            ref="inProgress"
            dense inset class="ml-auto" label="On" 
            :input-value="value.inProgress"
          />
        </div>
        <div class="d-flex align-center">
          <div style="white-space: nowrap" class="mr-4">Time Period:</div>
          <v-select 
            ref="period"
            :items="items" 
            :item-text="i => i.label"
            :item-value="i => i.value"
            outlined dense hide-details
            class="flex-shrink-1"
            :value="value.period"
          />
        </div>
      </div>

      <v-divider class="my-3" />

      <div class="d-flex justify-center">
        <v-btn @click="dialog_visible = false"> Cancel </v-btn>
        <v-btn class="ml-2" color="primary" @click="okClick"> Ok </v-btn>
      </div>

    </div>
  </v-dialog>
</template>

<script>
export default {
  props: ['value'],

  data() {
    return {
      dialog_visible: false,

      items: [
        { label: 'today', value: 1 },
        { label: 'last 7 days', value: 7 },
        { label: 'last 30 days', value: 30 },
        { label: 'last 90 days', value: 90 },
        { label: 'all', value: null },
      ],
    }
  },

  methods: {
    okClick() {
      this.dialog_visible = false
      this.$emit('input', {
        period: this.$refs.period.internalValue,
        inProgress: this.$refs.inProgress.internalValue ? true : false,
      })
    }
  },
}
</script>